import { map, Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SettingsService } from '../services/settings.service';
import { ServerResponse } from '../response';
import { User } from '../models/user';
import { Hof } from '../models/hof';

@Injectable({
  providedIn: 'root',
})
export class UserDomainService {
  constructor(
    private settingService: SettingsService,
    private http: HttpClient
  ) {}

  // Получение данных пользователя по uid
  getUserByUid(uid: string): Observable<User> {
    return this.http
      .get<ServerResponse<any>>(
        `${this.settingService.settings.urlGTM}/api/user?uid=${uid}&lang=${this.settingService.selectedLang}`
      )
      .pipe(
        map((res: any) => res.data)
      );
  }

  // Получение данных пользователя по телефону
  getUserByPhone(phone: string): Observable<{ cUid: string; isEmailVerified: boolean }> {
    return this.http
      .get<ServerResponse<{ cUid: string; isEmailVerified: boolean }>>(
        `${this.settingService.settings.urlGTM}/api/user/uid_by_phone?phone=${phone}&lang=${this.settingService.selectedLang}`
      )
      .pipe(
        map((res) => res.data)
      );
  }

  // Получение данных о пользователе (info)
  getCompetitorInfo(cUid: string): Observable<{ cUid: string; info: string }> {
    return this.http
      .get<ServerResponse<string>>(`${this.settingService.settings.urlGTM}/api/user/info?cUid=${cUid}&lang=${this.settingService.selectedLang}`)
      .pipe(
        map((res) => {
          return { cUid, info: res.data };
        })
      );
  }

  // Обновление данных о пользователе (info)
  patchCompetitorInfo(rUid: string, cUid: string, info: string): Observable<boolean> {
    return this.http
      .patch<ServerResponse<boolean>>(`${this.settingService.settings.urlGTM}/api/user/info`, { rUid, cUid, info, lang: this.settingService.selectedLang })
      .pipe(
        map(() => true)
      );
  }

  // Сохранение профиля пользователя
  saveProfile(user: User): Observable<User> {
    return this.http
      .post<ServerResponse<any>>(
        `${this.settingService.settings.urlGTM}/api/user/`,
        { user, lang: this.settingService.selectedLang }
      )
      .pipe(
        map((res: any) => res.data)
      );
  }

  // Обновление данных сессии пользователя
  updateProfileInCurrentSession(): Observable<void> {
    return this.http
      .patch(
        `${this.settingService.settings.urlGTM}/api/user/current_session`,
        {}
      )
      .pipe(
        map(() => undefined)
      );
  }

  // Отправка письма для подтверждения email
  sendCheckEmail(cUid: string, email: string): Observable<void> {
    return this.http
      .post(
        `${this.settingService.settings.urlGTM}/api/user/email/init_verification`,
        {
          cUid,
          email,
          lang: this.settingService.selectedLang,
        }
      )
      .pipe(
        map(() => undefined)
      );
  }

  // Проверка номера телефона (для изменения номера)
  setPhoneVerified(phone: string, cUid: string, pincode: string): Observable<any> {
    return this.http
      .patch<ServerResponse<any>>(
        `${this.settingService.settings.urlGTM}/api/user/phone`,
        { phone, cUid, pincode, lang: this.settingService.selectedLang }
      )
      .pipe(
        map((response: ServerResponse<any>) => response.data)
      );
  }

  // Получает данные hof гонок участника
  getHof(cUid: string): Observable<Hof[] | undefined> {
    return this.http
      .get<ServerResponse<any>>(`${this.settingService.settings.urlGTM}/api/user/hof?cUid=${cUid}`)
      .pipe(
        map((res: ServerResponse<any>) => res.data)
      );
  }

  // Сохранение данных команды пользователя
  saveTeam(rUid: string, cUid: string, team: any): Observable<any> {
    return this.http
      .patch(`${this.settingService.settings.urlGTM}/api/user/team`, {
        rUid,
        cUid,
        team,
        lang: this.settingService.selectedLang,
      })
      .pipe(
        map((res: any) => res.data)
      );
  }
}
